// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import { globalQueryClient } from "queries/queryClient";
import type {
  ExportAnswersDetailProps,
  ExportParams,
  ExportProps,
  ExportResponse,
  ExportResponsesResponse,
} from "types/exports";

import {
  getExport,
  getExportAnswers,
  getExportResponses,
  getExports,
} from "./services/loadExports";

export const useLoadExports = (
  params: ExportParams,
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ExportResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.EXPORTS.LIST, params],
    queryFn: ({ signal }) => {
      return getExports(params, { signal });
    },
    ...options,
  });
};

export const invalidateLoadExports = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.EXPORTS.LIST],
    exact: false,
  });
};

export const useLoadExport = (
  { id }: { id: string },
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ExportProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.EXPORTS.GET, { id }],
    queryFn: () => {
      return getExport({ id });
    },
    staleTime: 60 * 10 * 1000, // 10 minutes
    ...options,
  });
};

export const useLoadExportAnswers = (
  id: string,
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ExportAnswersDetailProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.EXPORTS.GET_ANSWERS, { id }],
    queryFn: () => {
      return getExportAnswers({ id });
    },
    staleTime: 60 * 10 * 1000, // 10 minutes
    ...options,
  });
};

export const useLoadExportResponses = (
  { id, params }: { id: string, params: ExportParams },
  options: any = {},
  // $FlowFixMe
): UseQueryResult<ExportResponsesResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.EXPORTS.GET_RESPONSES, { id, params }],
    queryFn: () => {
      return getExportResponses({ id, params });
    },
    ...options,
  });
};
